:host{box-shadow:0 -8px 8px -8px #0003}
/*# sourceMappingURL=footer.component-VR22TP6E.css.map */
